module.exports = __webpack_public_path__ + "media/images/ico-fullscreen@2x-eb639d65bba732ea4ec05d964c18b53e.png";